import React,{useState, useEffect, Fragment} from "react";
import { Link, useNavigate } from 'react-router-dom'
import axios from "axios";
import RichTextEditor from "@mantine/rte";
import { ButtonGroup, DatePicker as DatePickers, Dropdown, Input, Button, Panel, Steps, Checkbox, InputGroup, Tooltip, InputNumber  } from "rsuite";
import moment from "moment";
import { Grid, Radio, Card } from "@nextui-org/react";
import { DatePicker, message, Space, TimePicker } from "antd";
import 'antd/dist/antd.css';
import { api, WorkshopListURL } from "../../../apis/urls";

const { MonthPicker, RangePicker } = DatePicker;

const CreateWorkshop = () => {

    const [title,setTitle] = useState('');
    const [description,setDescription] = useState('');
    const [startDate,setStartDate] = useState('');
    const [startTime,setStartTime] = useState('');
    const [endDate,setEndDate] = useState('');
    const [endTime,setEndTime] = useState('');
    const [location, setLocation] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [states,setStates] = useState('GA');
    const [zip, setZip] = useState('');
    const [pageURL, setPageURL] = useState('');
    const [preg, setPreg] = useState("NO");
    const [mschool, setMSchool] = useState('NO');
    const [pPrice,setPPrice] = useState('');
    const [nmPrice, setNMprice] = useState(null);
    const [rdead, setRdead] = useState('');
    const [lrPrice, setLRprice]=useState('');
    const [mnAtte, setMNatte]=useState(1);
    const [prePrice, setPrePrice]=useState('')
    const [regSchool, setRegSchool] = useState('');
    const [conSchool, setConSchool] = useState('');
    const [regFir, setRegFir]=useState('');
    const [regLas, setRegLas]=useState('');
    const [regTit, setRegTit]=useState('NOTSHOW');
    const [regEmail, setRegEmail]=useState('');
    const [regSpe, setRegSpe]=useState('NOTSHOW');
    const [regPhone, setRegPhone]=useState('');

    const [newTime, setNewTime]=useState('');

    const [titleErr,setTitleErr] = useState(false);
    const [descriptionErr,setDescriptionErr] = useState(false);
    const [startDateErr,setStartDateErr] = useState(false);
    const [startTimeErr,setStartTimeErr] = useState(false);
    const [endDateErr,setEndDateErr] = useState(false);
    const [endTimeErr,setEndTimeErr] = useState(false);
    const [locationErr, setLocationErr] = useState(false);
    const [addressErr, setAddressErr] = useState(false);
    const [cityErr, setCityErr] = useState(false);
    const [statesErr,setStatesErr] = useState(false);
    const [zipErr, setZipErr] = useState(false);
    const [pageURLErr, setPageURLErr] = useState(false);


    const [nameErr,setNameErr] = useState(false);
    const [sDateErr,setSDateErr] = useState(false);
    const [eDateErr,setEDateErr] = useState(false);
    const [sTimeErr,setSTimeErr] = useState(false);
    const [eTimeErr,setETimeErr] = useState(false);
  
    const [nameErrInd,setNameErrInd] = useState('');
    const [sDateErrInd,setSDateErrInd] = useState('');
    const [eDateErrInd,setEDateErrInd] = useState('');
    const [sTimeErrInd,setSTimeErrInd] = useState('');
    const [eTimeErrInd,setETimeErrInd] = useState('');

    const [nmPriceErr, setNmemPriceErr]=useState(false);
    const [pPriceErr, setPPriceErr] = useState(false);

    const [dateSel, setDateSel] = useState('')

    


    const statess = ["AL","AK","AS","AR","AZ","CA","CO","CT","DE","DC","FM","FL","GA","GU","HI","ID","IL","IN","IA","KS","KY","LA","ME","MH","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PW","PA","PR","RI","SC","SD","TN","TX","UT","VT","VI","VA","WA","WV","WI","WY"];
    const datavalidation = [{value: 'NOT_SHOW', label:"Do not show"},{value: 'REQUIRED', label:"REQUIRED"}, {value:'OPTIONAL',label:"OPTIONAL"}].map(item => ({ label: item.label, value: item.value }));
    const datavalidations = [{value: 'REQUIRED', label:"REQUIRED"}, {value:'OPTIONAL',label:"OPTIONAL"}].map(item => ({ label: item.label, value: item.value }));

    useEffect(() => {
        let value = moment(startDate).format("YYYY-MM-DD") +' '+ startTime+':00'
    })

    

    const [inputFields, setInputFields] = useState([
        {sessionName:'',startDate: '', endDate: ''}
    ]);
    
    const handleAddFields = (index) => {
        const values = [...inputFields];
        values.push({sessionName:'',startDate:'', endDate:''});

        let error = false
    
        // setInputFields(values);    

        if(inputFields[index].sessionName === '' || inputFields[index].startDate=== '' || inputFields[index].endDate === ''
        )
        {
            error = true
        }else{
            setInputFields(values);  
        }
    
     




    if(inputFields[index].sessionName === ''){
        setNameErr(true)
        setNameErrInd(index)
    }else{
        setNameErr(false)
    }

    if(inputFields[index].startDate === ''){
        setSDateErr(true)
        setSDateErrInd(index)
    }else{
        setSDateErr(false)
    }

    if(inputFields[index].endDate === ''){
        setEDateErr(true)
        setEDateErrInd(index)
    }else{
        setEDateErr(false)
    }




    
    };


    const handleSubmit = e => {
        e.preventDefault();
    };


    const handleInputChange = (index, event, name) => {

        const values = [...inputFields];

        console.log(event)

        if (name === "sessionName") {
            values[index].sessionName = event.target.value;
        }else if(name === "startDate"){
            values[index].startDate = event;
        }else if(name === "endDate"){
            values[index].endDate = event;
        }
        setInputFields(values);
    };

    const handleRemoveFields = index => {
        const values = [...inputFields];
        values.splice(index, 1);
        setInputFields(values);
    };


    const [step, setStep] = useState(0);
    const onChange = nextStep => {
    setStep(nextStep < 0 ? 0 : nextStep > 3 ? 3 : nextStep);
    };
    
    const onNext = () => {

        if(step === 0)
        {
        if(title === '' || title.length < 2 || location === '' || city === '' || states === '')
        {
            if(title === '' || title.length < 2){
                setTitleErr(true)
            }else{
                setTitleErr(false)
            }

            if(location === ''){
                setLocationErr(true)
            }else{
                setLocationErr(false)
            }

            // if(address === ''){
            //     setAddressErr(true)
            // }else{
            //     setAddressErr(false)
            // }

            if(city === ''){
                setCityErr(true)
            }else{
                setCityErr(false)
            }

            if(states === ''){
                setStatesErr(true)
            }else{
                setStatesErr(false)
            }



            // if(startTime === ''){
            //     setStartTimeErr(true)
            // }else{
            //     setStartTimeErr(false)
            // }
            // if(endTime === ''){
            //     setEndTimeErr(true)
            // }else{
            //     setEndTimeErr(false)
            // }

            if(startDate === ''){
                setStartDateErr(true)
            }else{
                setStartDateErr(false)
            }
            if(endDate === ''){
                setEndDateErr(true)
            }else{
                setEndDateErr(false)
            }






            // if(zip === ''){
            //     setZipErr(true)
            // }else{
            //     setZipErr(false)
            // }



            // if(pageURL === ''){
            //     setPageURLErr(true)
            // }else{
            //     setPageURLErr(false)
            // }
        }else{
            setTitleErr(false)
            setLocationErr(false)
            setAddressErr(false)
            setCityErr(false)
            setStatesErr(false)
            setZipErr(false)
            setPageURLErr(false)
            setStartTimeErr(false)
            setEndTimeErr(false)
            onChange(step + 1);
        }
    }

    if(step === 1){


        if(pPrice === '' || mschool === 'NO' && !nmPrice)
        {

            if(pPrice === ''){
                setPPriceErr(true)
            }else
            {
                setPPriceErr(false)
    
            }
            
            if(mschool === 'NO' && !nmPrice){    
                setNmemPriceErr(true)
            }else{
                setNmemPriceErr(false)
            }

        }

        else{
            onChange(step + 1);
        }

    }


    if(step === 2){
        onChange(step + 1);
    }


    

    };



    const onPrevious = () => onChange(step - 1);


    let navigate = useNavigate();
    const RoutToList = () =>{

        let path = 'newPath'; 
        navigate("/workshop")
        
    }


    const EventSubmit = () => {

        // setLoading(true)


        const indexValue = inputFields.length - 1

        if(inputFields[indexValue].sessionName === '' || inputFields[indexValue].startDate === '' || inputFields[indexValue].endDate === '')
        {

            

            if(inputFields[indexValue].sessionName === ''){
                setNameErr(true)
                setNameErrInd(indexValue)
            }else{
                setNameErr(false)
            }
        
            if(inputFields[indexValue].startDate === ''){
                setSDateErr(true)
                setSDateErrInd(indexValue)
            }else{
                setSDateErr(false)
            }
        
            if(inputFields[indexValue].endDate === ''){
                setEDateErr(true)
                setEDateErrInd(indexValue)
            }else{
                setEDateErr(false)
            }
        




        }else{


            let token = "Bearer "+localStorage.getItem('token');
            const data = {
                title:title,
                description:description,
                start_date:startDate,
                end_date:endDate,
                location:location,
                address:address,
                city:city,
                state:states,
                zipcode:zip, 
                link_url:pageURL,
                participant_registration:preg,
                member_schools: mschool,
                participant_price: pPrice,
                non_member_price: nmPrice,
                registration_deadline: rdead === ''?endDate:rdead,
                late_registration_price: lrPrice,
                max_number_attendees: mnAtte,
                presenter_price: prePrice,
                reg_school_org: "NOTSHOW",
                contact_school_org: "NOTSHOW",
                reg_firstname: "REQUIRED",
                reg_lastname: "REQUIRED",
                reg_title_school: regTit,
                reg_email: "REQUIRED",
                reg_special_dietery: "NOTSHOW",
                reg_phone: "REQUIRED",
                sessions:inputFields,
                image:fileUp
            }
            
            
            const instance = axios.create({

                baseURL: WorkshopListURL,

                timeout: 1000000,

                headers: {'authorization': token}

            });
                        
            instance.post('',data).then((response) =>{
    
                message.success(title+' conference manager created successfully')

                navigate("/workshop")

            }).catch((error) =>{

                console.log("123456", error)
            });

        }
    }


    const checkCofirm = event => {
        console.log("event.target.value", event)
        if (event === "NO") {
          setPreg("YES")
        } else {
            setPreg("NO")
        }
      };

      const checkCofirm1 = event => {
        console.log("event.target.value", event)
        if (event === "NO") {
            setMSchool("YES")
        } else {
            setMSchool("NO")
        }
      };


      const onChanges = (value, dateString) => {
        console.log('Selected Time: ', value);
        setStartDate(dateString[0])
        setEndDate(dateString[1])

        console.log('Formatted Selected Time: ', dateString);
      };
      const onOk = (value) => {
        console.log('onOk: ', value);
      };


      const maxAtte =(e)=>{
        setMNatte(e)
        if(e === "0"){
            alert("Minimum add 1 attendee ")
        }
      }




      const [fileUp, setFileUp] = useState('');
      const [fileSelect, setFileSelect] = useState('');

      const [disabled, setDisabled] = useState(false)

      const  changeHandler=(event)=>{
  
          setFileSelect(event.name)
          setDisabled(true)
  
          let token = "Bearer "+localStorage.getItem('token');
  
          const data = new FormData();
  
          data.append('file', event)
  
          const instance = axios.create({
              baseURL: api+ 'workshopImage/upload',
              timeout: 1000000,
              headers: {'authorization': token, "Content-Type":  "multipart/form-data"},
          });
  
  
          instance.post('', data).then((response) =>{
  
              console.log("respooonse", response.data)
              setFileUp(response.data.Location)
              setDisabled(false)
  
          }).catch((error) =>{     
              console.log('error',error.message)  
          });
  
      }
  




      



    return(
        <Fragment>


            {step ===4?null:
            <Steps current={step}>
                <Steps.Item title="General Event Information" description="" />
                <Steps.Item title="Participant Information" description="" />
                <Steps.Item title="Registration Form Configuration" description="" />
                <Steps.Item title="Add Sessions" description="" />
            </Steps>
            }

        <hr />   

        {step === 0?
            <Panel header={`General Event Information`}>
                <form className="needs-validation" noValidate>
                    <div className="form-wrpr">

                        <div className="cards formcard medium">
                            <div className="cards-body" >

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-12" >
                                            <label style={{fontSize:'14px', color:'black', }} className="degreehead">Event Title<span style={{color: "red"}}>*</span></label>
                                            <Input style={{fontSize:'14px', color:'black', }}value={title} onChange={setTitle} placeholder="Enter Title" />
                                            {titleErr?<span style={{color:'red', fontSize:12}}>Title is Required. </span>:null}
                                            </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <label style={{fontSize:'14px', color:'black', }} className="degreehead">Description</label>
                                            <RichTextEditor value={description} onChange={setDescription}  />

                                        </div>
                                    </div>
                                </div>

                                {/* <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label style={{fontSize:'14px', color:'black', }} >Start Date:<span style={{color: "red"}}>*</span></label><br />	
                                            <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <DatePicker 
                                                        oneTap={true}
                                                        onChange={(date) => {
                                                        // const d = new Date(date).toLocaleDateString('fr-FR');
                                                        setStartDate(date);
                                                        console.log(date)
                                                        }}
                                                        style={{width:'200%'}}
                                                        defaultValue={startDate?startDate:null}
                                                        className="form-controls" size="lg"  placeholder={startDate?startDate:"Start Date (YYYY-MM-DD)"} />
                                                    {startDateErr?<span style={{color:'red', fontSize:12}}>Start Date is Required.</span>:null}

                                                    </div>
                                                    <div className="col-md-6">
                                                        <Input style={{fontSize:'14px', color:'black', }}onChange={(time) => {setStartTime(time)}} defaultValue={startTime?startTime:null} type="time" />
                                                        {endTimeErr?<span style={{color:'red', fontSize:12}}>Start time is Required.</span>:null}                                 
                                                    </div>
                                                </div>
                                            </div>                                    
                                        </div>	

                                        <div className="col-md-6">
                                            <label style={{fontSize:'14px', color:'black', }} >End Date:<span style={{color: "red"}}>*</span></label><br />	
                                            <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <DatePicker
                                                        oneTap={true}                                                   
                                                        onChange={(date) => {
                                                        const d = new Date(date).toLocaleDateString('fr-FR');
                                                        setEndDate(date);
                                                        console.log(date)
                                                        }}
                                                        style={{width:'200%'}}
                                                        defaultValue={endDate?endDate:null}
                                                        className="form-controls" size="lg"  placeholder={endDate?endDate:"End Date (YYYY-MM-DD)"} />
                                                    {endDateErr?<span style={{color:'red', fontSize:12}}>End Date is Required.</span>:null}

                                                    </div>
                                                    <div className="col-md-6">
                                                        <Input style={{fontSize:'14px', color:'black', }}onChange={(time) => {setEndTime(time)}} defaultValue={endTime?endTime:null} type="time" /> 
                                                        {endTimeErr?<span style={{color:'red', fontSize:12}}>End time is Required.</span>:null}
                                                    </div>
                                                </div>
                                            </div>                                    
                                        </div>									

                                    </div>
                                </div> */}



                                {/* <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-12">
										    <label style={{fontSize:'14px', color:'black', }} >Date:<span style={{color: "red"}}>*</span></label><br />

                                            <Space direction="vertical" size={12}>
                                                <RangePicker
                                                showTime={{
                                                    format: 'HH:mm a',
                                                }}
                                                defaultValue={startDate && endDate ?[
                                                    moment(startDate, "MM-DD-YYYY HH:mm a"),
                                                    moment(endDate, "MM-DD-YYYY HH:mm a")
                                                ]:null}
                                                format="MM-DD-YYYY HH:mm a"
                                                onChange={onChanges}
                                                onOk={onOk}
                                                />
                                            </Space>
                                            {startDateErr === true && endDateErr === true?<span style={{color:'red', fontSize:12}}>Date is Required.</span>:null}

                                        </div>						
                                    </div>
                                </div> */}

{/* 
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-12">
										    <label style={{fontSize:'14px', color:'black', }} >Date:<span style={{color: "red"}}>*</span></label><br />

                                            <Space direction="vertical" size={12}>
                                                <RangePicker
                                                showTime={{
                                                    format: 'hh:mm a',
                                                }}
                                                defaultValue={startDate && endDate ?[
                                                    moment( moment(startDate).format('MM-DD-YYYY hh:mm a'), "MM-DD-YYYY hh:mm a"),
                                                    moment( moment(endDate).format('MM-DD-YYYY hh:mm a'), "MM-DD-YYYY hh:mm a")
                                                ]:null}
                                                format="MM-DD-YYYY hh:mm a"
                                                onChange={onChanges}
                                                onOk={onOk}
                                                />
                                            </Space>
                                            {startDateErr === true && endDateErr === true?<span style={{color:'red', fontSize:12}}>Date is Required.</span>:null}

                                        </div>							
                                    </div>
                                </div> */}

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
										    <label style={{fontSize:'14px', color:'black', }} >Date:<span style={{color: "red"}}>*</span></label><br />
                                            <DatePicker
                                                showTime={{ format: 'hh:mm a' }}
                                                format="MM-DD-YYYY hh:mm a"
                                                placeholder="Select Start Date"
                                                style={{width:"100%", height:"45px", borderRadius:"5px"}}  
                                                onChange={(e)=>{setStartDate(e)}} 
                                                />
                                            {startDateErr === true ? <span style={{color:'red', fontSize:12}}>End Date is Required.</span>:null}
                                        </div>		
                                        <div className="col-md-6">
										    <label style={{fontSize:'14px', color:'black', }} >Date:<span style={{color: "red"}}>*</span></label><br />
                                            <DatePicker
                                                showTime={{ format: 'HH:mm a' }}
                                                format="MM-DD-YYYY hh:mm a"
                                                placeholder="Select End Date"
                                                style={{width:"100%", height:"45px", borderRadius:"5px"}}  
                                                onChange={(e)=>{setEndDate(e)}}
                                                // diplay on 12 hours format
                                            />
                                            {endDateErr === true?<span style={{color:'red', fontSize:12}}>End Date is Required.</span>:null}
                                        </div>							
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
										    <label style={{fontSize:'14px', color:'black', }} >Location:<span style={{color: "red"}}>*</span></label>
                                            <Input style={{fontSize:'14px', color:'black', }}value={location} onChange={setLocation} placeholder="Enter Location" /> 
                                            {locationErr?<span style={{color:'red', fontSize:12}}>Location is Required.</span>:null}
                                       
                                        </div>
                                        <div className="col-md-6">
										    <label style={{fontSize:'14px', color:'black', }} >Address:</label>
                                            <Input style={{fontSize:'14px', color:'black', }}value={address} onChange={setAddress} placeholder="Enter Address" />                                        
                                            {addressErr?<span style={{color:'red', fontSize:12}}>Address is Required.</span>:null}

                                        </div>								
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
										    <label style={{fontSize:'14px', color:'black', }} >City:<span style={{color: "red"}}>*</span></label>
                                            <Input style={{fontSize:'14px', color:'black', }}value={city} onChange={setCity} placeholder="Enter City" />                                        
                                            {cityErr?<span style={{color:'red', fontSize:12}}>City is Required.</span>:null}

                                        </div>
                                        <div className="col-md-6">
										    <label style={{fontSize:'14px', color:'black', }} >State:<span style={{color: "red"}}>*    </span></label><br/>
                                            <Dropdown title={states?states:"Select State"}
                                             style={{ width:'100%'}}  >
                                                {statess.map((item, index)=> (

                                                    <Fragment key={index}>
                                                    <Dropdown.Item value={item}

                                                        onClick={() => {{setStates(item);
                                                            // console.log("aaaa")
                                                            }}}

                                                        >{item}</Dropdown.Item>
                                                    </Fragment>
                                                ))}
                                            </Dropdown>
                                            {statesErr?<span style={{color:'red', fontSize:12}}>State is Required.</span>:null}

                                        </div>				
				
                                    </div>

                                </div>


                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">
										    <label style={{fontSize:'14px', color:'black', }} >Zipcode:</label>
                                            <Input style={{fontSize:'14px', color:'black', }}value={zip} onChange={setZip} placeholder="Enter Zipcode" /> 
                                            {zipErr?<span style={{color:'red', fontSize:12}}>Zipcode is Required.</span>:null}
                                      
                                        </div>
                                        <div className="col-md-6">
										    <label style={{fontSize:'14px', color:'black', }} >Detail Page URL:</label>
                                            <Input style={{fontSize:'14px', color:'black', }}value={pageURL} onChange={setPageURL} placeholder="Enter Detail Page URL" />                                        
                                            {pageURLErr?<span style={{color:'red', fontSize:12}}>Link is Required.</span>:null}
 
                                        </div>								
                                    </div>
                                </div>



                            <div className="form-group">
								<div className="row">
									<div className="col-md-12">	
										<label >Upload image</label>	
										<div>
											<div class='file-input' style={{background:"#e6e8eaab", width:'100%'}}>
											<input type='file' onChange={(event)=>{changeHandler(event.target.files[0]);}}  />	
                                            {!fileUp?
											    <span span class='button' style={{background:'dodgerblue', color:'#fff', fontWeight:'500', fontSize:'12px'}}>Choose</span>:
                                                <img src={fileUp} width="5%" />
                                            }
											<span class='labels' style={{color:fileUp?'dodgerblue':'gray', fontWeight:'500', fontSize:'12px', paddingLeft:fileUp?'10px':null }} data-js-label>{!fileSelect?"No file selected":fileSelect}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
    


                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-12" >
                                            {/* <Checkbox value={preg === "NO"?"NO":"YES"} checked={preg === "NO"?false:true} onChange={checkCofirm}>Event is open for participant registration (Participants can only register when this is checked.)</Checkbox> */}
                                            <Checkbox style={{color:'#000'}} value={mschool === "NO"?"NO":"YES"} checked={mschool === "NO"?false:true} onChange={checkCofirm1}><p style={{fontSize:'16px', fontWeight:'500'}}>Event is open to member schools only (Only participants from GISA member schools can register when this is checked.)</p></Checkbox>
                                        </div>
                                    </div>
                                </div>

                                <h6 style={{color: "red"}}>* REQUIRED Fields</h6>
                                
                            </div>
                        </div>
                        
                    </div>
                </form>
            </Panel>:null
        }

        {step ===1?
            <Panel header={`Participant Information`}>
                <form className="needs-validation" noValidate>
                    <div className="form-wrpr">
                        <div className="cards formcard medium">
                            <div className="cards-body" >
                                
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6" >
                                            <label style={{fontSize:'14px', color:'black', }} >Participant price :</label>
                                                <InputNumber style={{fontSize:'14px', color:'black', }}value={pPrice} onChange={setPPrice} prefix="$" />
                                            {pPriceErr?<span style={{color:'red', fontSize:12}}>Participant price is Required.</span>:null}
     
                                            <label style={{fontSize:'14px', color:'black', }} >(for members)</label>                               
                                        </div>
                                        <div className="col-md-6" >
                                        <label style={{fontSize:'14px', color:'black', }} >Non member participant price :</label>
                                            <InputNumber min={pPrice}  disabled={mschool ==="YES"?true:false} style={{fontSize:'14px', color:'black', }} value={nmPrice} onChange={setNMprice}  prefix="$" />
     
                                            {nmPriceErr?<span style={{color:'red', fontSize:12}}>Non-Member price is Required.</span>:null}

                                            
                                            <label style={{fontSize:'14px', color:'black', }} >(Leave blank or enter 0 if same as member price or if nonmember participants are not allowed.)  </label>                                     
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6" >
                                            <label style={{fontSize:'14px', color:'black', }} >Registration deadline :</label>
                                                <DatePicker 
                                                    oneTap={true}
                                                    onChange={(date) => {
                                                    // const d = new Date(date).toLocaleDateString('fr-FR');
                                                    setRdead(date);
                                                    console.log(date)
                                                    }}
                                                    format={'MM-DD-YYYY'}
                                                    style={{width:'100%', height:'45px', borderRadius:'5px'}}
                                                    defaultValue={rdead?rdead:null}
                                                    className="form-controls" size="lg"  placeholder={rdead?rdead:"Deadline Date (MM-DD-YYYY)"} />                        
                                        </div>
                                        <div className="col-md-6" >
                                        <label style={{fontSize:'14px', color:'black', }} >Additional Price for Late registration :</label>
                                            <InputNumber  style={{fontSize:'14px', color:'black', }}value={lrPrice} onChange={setLRprice}  prefix="$" />

                                            <label style={{fontSize:'14px', color:'black', }} >Enter total price for event if registering after deadline. Enter zero if late registration will NOT be allowed.</label>                                     
                                        </div>
                                    </div>
                                </div>


                                <h6 style={{color: "red"}}>* REQUIRED Fields</h6>



                            </div>
                        </div>
                    </div>
                </form>
           </Panel>:null
        }

        {step === 2?
                <Panel header={`Registration Form Configuration`}>



                <form className="needs-validation" noValidate>
                    <div className="form-wrpr">
                        <div className="cards formcard medium" >
                            <div className="cards-body">
                                {regFir}
                                <div className="form-group">
                                    <div className="row" style={{paddingTop:'20px'}}>
                                        <div className="col-md-4">
                                            <label style={{fontSize:'14px', color:'black', fontWeight:500}} >Registrants firstname field</label><br />
                                        </div>
                                        <div className="col-md-8" >
                                            <Radio.Group defaultValue="REQUIRED" orientation="horizontal" onChange={(value)=>{setRegFir(value)}}>
                                            <Radio size="xl" value="REQUIRED" color="primary" labelColor="primary">
                                                REQUIRED
                                            </Radio>
                                            <Radio size="xl" value="OPTIONAL" isDisabled color="secondary" labelColor="secondary">
                                                OPTIONAL
                                            </Radio>
                                            <Radio size="xl" value="NOTSHOW" isDisabled  color="error" labelColor="error">
                                                Not Show
                                            </Radio>
                                            </Radio.Group>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row" style={{paddingTop:'20px'}}>
                                        <div className="col-md-4">
                                            <label style={{fontSize:'14px', color:'black', fontWeight:500}} >Registrants lastname field</label><br />
                                        </div>
                                        <div className="col-md-8" >
                                            <Radio.Group defaultValue="REQUIRED" orientation="horizontal" onChange={(value)=>{setRegLas(value)}}>
                                            <Radio size="xl" value="REQUIRED" color="primary" labelColor="primary">
                                                REQUIRED
                                            </Radio>
                                            <Radio size="xl" value="OPTIONAL" isDisabled  color="secondary" labelColor="secondary">
                                                OPTIONAL
                                            </Radio>
                                            <Radio size="xl" value="NOTSHOW"  isDisabled color="error" labelColor="error">
                                                Not Show
                                            </Radio>
                                            </Radio.Group>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row" style={{paddingTop:'20px'}}>
                                        <div className="col-md-4">
                                            <label style={{fontSize:'14px', color:'black', fontWeight:500}} >Registrants phone field</label><br />
                                        </div>
                                        <div className="col-md-8" >
                                            <Radio.Group defaultValue="REQUIRED" orientation="horizontal" onChange={(value)=>{setRegEmail(value)}}>
                                            <Radio size="xl" value="REQUIRED" color="primary" labelColor="primary">
                                                REQUIRED
                                            </Radio>
                                            <Radio size="xl" value="OPTIONAL" isDisabled  color="secondary" labelColor="secondary">
                                                OPTIONAL
                                            </Radio>
                                            <Radio size="xl" value="NOTSHOW" isDisabled  color="error" labelColor="error">
                                                Not Show
                                            </Radio>
                                            </Radio.Group>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row" style={{paddingTop:'20px'}}>
                                        <div className="col-md-4">
                                            <label style={{fontSize:'14px', color:'black', fontWeight:500}} >Registrants email field</label><br />
                                        </div>
                                        <div className="col-md-8" >
                                            <Radio.Group defaultValue="REQUIRED" orientation="horizontal" onChange={(value)=>{setRegPhone(value)}}>
                                            <Radio size="xl" value="REQUIRED" color="primary" labelColor="primary">
                                                REQUIRED
                                            </Radio>
                                            <Radio size="xl" value="OPTIONAL" isDisabled  color="secondary" labelColor="secondary">
                                                OPTIONAL
                                            </Radio>
                                            <Radio size="xl" value="NOTSHOW" isDisabled  color="error" labelColor="error">
                                                Not Show
                                            </Radio>
                                            </Radio.Group>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row" style={{paddingTop:'20px'}}>
                                        <div className="col-md-4">
                                            <label style={{fontSize:'14px', color:'black', fontWeight:500}} >Registrants title at school field</label><br />
                                        </div>
                                        <div className="col-md-8" >
                                            <Radio.Group defaultValue="NOTSHOW" orientation="horizontal" onChange={(value)=>{setRegTit(value)}}>
                                            <Radio size="xl" value="REQUIRED" color="primary" labelColor="primary">
                                                REQUIRED
                                            </Radio>
                                            <Radio size="xl" value="OPTIONAL"  color="secondary" labelColor="secondary">
                                                OPTIONAL
                                            </Radio>
                                            <Radio size="xl" value="NOTSHOW"  color="error" labelColor="error">
                                                Not Show
                                            </Radio>
                                            </Radio.Group>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </form>

                </Panel>:null
        }


        

        {step === 3?
            <Panel header={`Add Session`}>



            <div class="main">
            <ul class="cards-session">


            {inputFields.map((inputField, index) => (

                <li class="cards_item">
                <div class="card-session">

                            <Panel className="public_label" header={`Session ` +(index+1)} style={{padding:'5px', paddingTop:'20px', paddingBottom:'20px'}}>
                                <form className="needs-validation" noValidate>
                                <div className="form-wrpr">
                                    <div className="cards formcard medium">
                                    <div className="cards-body" >
                                                <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-12"  style={{marginTop:'20px'}}>
                                                <label>Session Name</label>  
                                                    <input 
                                                    placeholder="Session Name" 
                                                    className='form-control public_input'
                                                    id="sessionName"
                                                    name="sessionName"
                                                    defaultValue={inputFields[index].sessionName}
                                                    value={inputField.name}
                                                    onChange={event => {handleInputChange(index, event, 'sessionName')}}/>
                                                {nameErr && nameErrInd === index?<p style={{color:"red",fontSize:'13px'}}>Please enter session name</p>:null}

                                                </div>
                                                <div className="col-md-12 sess-eve-date"  style={{marginTop:'20px'}}>
                                                <label>Start Date</label>  
                                                    <DatePicker size="lg" placeholder="Start Date (MM-DD-YYYY)" 
                                                    format={"MM-DD-YYYY hh:mm a"}
                                                    showTime
                                                    defaultValue={inputFields[index].startDate ? moment(inputFields[index].startDate, 'MM-DD-YYYY HH:mm a') : null}
                                                    onChange={event => {handleInputChange(index, event, 'startDate')}} />
                                                {sDateErr && sDateErrInd === index?<p style={{color:"red",fontSize:'13px'}}>Please enter start date</p>:null}

                                                </div> 





                                                <div className="col-md-12 sess-eve-date"  style={{marginTop:'20px'}}>
                                                    <label>End Date</label>  
                                                    <DatePicker size="lg"
                                                        defaultValue={inputFields[index].endDate ? moment(inputFields[index].startDate, 'MM-DD-YYYY HH:mm a') : null}
                                                        placeholder="End Date (MM-DD-YYYY)"
                                                        format={"MM-DD-YYYY hh:mm a"}
                                                        showTime
                                                        className="start-date-picker" 
                                                        onChange={event => {handleInputChange(index, event, 'endDate')}} />
                                                    {eDateErr && eDateErrInd === index?<p style={{color:"red",fontSize:'13px'}}>Please enter end date</p>:null}

                                                </div>


                                    <div className="col-md-6"  style={{marginTop:'30px'}}>

                                    <div className="page-rightside-action-column">

                                        {inputFields.length - index === 1?

                                        <button
                                            style={{background:'red', color:'#fff',  borderRadius:'10px', padding:'12px', width:'100%', fontSize:'14px', minWidth:'100%'}}                                  
                                            type="button"
                                            className='addbtnitem-link text-anchor'
                                            disabled={index === 0}
                                            onClick={() => handleRemoveFields(index)}
                                        >
                                        <i className="icon-times" style={{fontSize:'20px', fontWeight:900}}></i><span style={{color:'#fff', fontSize:'15px', paddingTop:'5px'}}>Remove Session</span>
                                        </button>:null}

                                    </div>

                                    </div>



                                    <div className="col-md-6"  style={{marginTop:'30px'}}>

                                    <div className="page-rightside-action-column">

                                        {inputFields.length - index === 1?

                                        <button
                                            style={{background:'#4077cf', color:'#fff',  borderRadius:'10px', padding:'12px', width:'100%', fontSize:'14px', minWidth:'100%'}}                                  
                                            type="button"
                                            className='addbtnitem-link text-anchor'
                                            onClick={() => handleAddFields(index)}
                                        >
                                        <i class="icon-add" style={{fontSize:'20px', fontWeight:900}}></i><span style={{color:'#fff', fontSize:'15px', paddingTop:'5px'}}>Add Session</span>
                                        </button>:null}

                                    </div>

                                    </div>
                                


                                            </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    </form>

                                    </Panel>  





                </div>
                </li>

            ))}

            </ul>
            </div>







            </Panel>:null
            
            
        }







        {step !== 4?
            <div> 
                <ButtonGroup style={{width:'100%', marginTop:'2%'}}>
                        <Button className="button-focus create-conference-btn prev-conference-btn" style={{background:'#fff', color:'#3498ff'}}  onClick={onPrevious} disabled={step === 0}>
                            Previous
                        </Button>
                    {step === 3?
                        <Button appearance="primary" className="button-focus create-conference-btn" onClick={EventSubmit} disabled={step === 1 || step === 2}>
                            Create Conference Manager
                        </Button>:
                        <Button appearance="primary" className="button-focus create-conference-btn" onClick={onNext} disabled={disabled}>
                            Next
                        </Button>
                    }
                </ButtonGroup>
            </div>:null
        }




           
        </Fragment>
    )
}

export default CreateWorkshop;
